import AssetItems from "./AssetItems.jsx";
import Filter from "./Filter.jsx";
import Listbox from "./Listbox.jsx";
import React, { useState, useEffect } from "react";

import { getAssetTypes, getAssets, getOrderByTypes } from "./api.js";

export default (props) => {

    const [ddFilters, setDDFilters] = useState([]);
    const defaultFilter = { description: 'Content Type', value: '', Display: 'Content Type', Value: '' };
    const defaultOrderBy = { description: 'File Date', value: 'FileDate' };
    const [activeDDFilter, setActiveDDFilter] = useState(defaultFilter);
    const [activeFilters, setActiveFilters] = useState([]);
    const [filters, setFilters] = useState([]);
    const [orderBy, setOrderBy] = useState(defaultOrderBy);
    const [orderByTypes, setOrderByTypes] = useState([]);

    function setDDLActiveFilter(x) {

        setActiveFilters([x.value]);

        setActiveDDFilter(x);
    }

    class Behavior {

        constructor(label, orderBy, orderByTypes, fnSetOrderBy, fnSetOrderByTypes) {

            this.FnSetOrderBy = fnSetOrderBy;
            this.FnSetOrderByTypes = fnSetOrderByTypes;
            this.Label = label;
            this.OrderBy = orderBy;
            this.OrderByTypes = orderByTypes;
        }   

        SetOrderBy = (x) => {
            this.FnSetOrderBy(x);
        }

        SetOrderByTypes = (x) => {
            this.FnSetOrderByTypes(x);
        }
    }

    const behavior = new Behavior('Order By', orderBy, orderByTypes, setOrderBy, setOrderByTypes);    

    useEffect(() => {
        getAssetTypes().then((d) => {

            const ddList = d.map(x => Object.assign(x, { value: x.value, description: x.display }));
            ddList.unshift(defaultFilter);
            setDDFilters(ddList);
            setFilters(d);
        });
    }, []);

    useEffect(() => {
        getOrderByTypes().then((d) => {
            behavior.SetOrderByTypes([...d]);
            if(d.length > 0)
                behavior.SetOrderBy(d[0]);
        });
    }, []);

    return (
        <div className="tw-grid lg:tw-grid-cols-5 tw-gap-4 tw-font-sans">
            <div className="tw-hidden lg:tw-block tw-overflow-x-hidden tw-pb-[60px] tw-ml-[-40px]">
                <Filter {...{ activeFilters, setActiveFilters, filters }} />
            </div>
            <div className="tw-block lg:tw-hidden tw-col-span-4 tw-mb-4">
                <Listbox
                    selectList={ddFilters}
                    selected={activeDDFilter}
                    setSelected={setDDLActiveFilter}
                />
            </div>
            <div className="tw-bg-white tw-col-span-4">
                <div className="tw-max-w-[905px] tw-mx-auto">
                    <section>
                        <AssetItems
                            itemLookup={props?.adsId}
                            itemLookupFn={getAssets}
                            activeFilters={activeFilters}
                            orderBy={orderBy?.value || ""}
                            resultsBehavior={behavior}
                        />
                    </section>
                </div>
            </div>
        </div>
    );
}